import { getReporter } from './reporter'

let memoryTimer: ReturnType<typeof setInterval> | null = null

/**
 * 采集内存使用情况
 *
 * 仅 Chromium 浏览器支持 performance.memory，
 * 每次 reporter flush 前调用 collectMemory() 采集一次快照
 */
export function setupMemory(): void {
  if (typeof window === 'undefined') return
  if (!performance.memory) return

  collectMemorySnapshot()
  memoryTimer = setInterval(collectMemorySnapshot, 30000)
}

/** 停止内存采集定时器 */
export function destroyMemory(): void {
  if (memoryTimer) {
    clearInterval(memoryTimer)
    memoryTimer = null
  }
}

/** 采集一次内存快照 */
function collectMemorySnapshot(): void {
  const reporter = getReporter()
  if (!reporter) return

  const memory = performance.memory
  if (!memory) return

  const used = memory.usedJSHeapSize / 1048576
  const total = memory.totalJSHeapSize / 1048576

  reporter.addMemory({
    usedJSHeapSize: Math.round(used * 100) / 100,
    totalJSHeapSize: Math.round(total * 100) / 100,
    heapUtilization: total > 0 ? Math.round((used / total) * 100) / 100 : 0,
    pagePath: location.pathname,
    timestamp: Date.now(),
  })
}
